var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hidden),expression:"!hidden"}],staticClass:"smvp-translation-tab"},[(_vm.labels.header)?_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.labels.header))]):_vm._e(),(_vm.src)?_c('iframe',{attrs:{"src":_vm.src,"width":"100%","height":"90%"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }